import React from 'react';

interface CustomFooterProps {
  html?: string | null;
  css?: string | null;
}

const CustomFooter: React.FC<CustomFooterProps> = ({ html, css }) => {
  if (!html) return null;

  return (
    <>
      {css && <style dangerouslySetInnerHTML={{ __html: css }} />}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </>
  );
};

export default CustomFooter;
